export default __webpack_public_path__ + "static/media/earlyNotSubscriberAndroid_5.f676bc5b.svg";